<template>
  <div id="multi-step-quiz" class="multi-step-quiz">
    <input ref="paramData" type="hidden" :value="paramData" />
    <div class="mt-2 flex flex-col justify-center items-center px-3">
      <div class="w-full">
        <va-text-input
          class="multi-step-quiz__url-input"
          :class="invalidUrl ? 'no-valid' : ''"
          :rules="[rules.urlValidation]"
          :label="$t('shortcodes.multiStepQuiz.url_for_redirect')"
          required
          v-model="redirectUrl"
          placeholder="https://domain.com">
        </va-text-input>
        <v-select
          :menu-props="{ offsetY: true, offsetOverflow: true }"
          outlined
          class="multi-step-quiz__select"
          v-model="redirectAction"
          filled
          label="Open redirect link in..."
          :items="actionData">
          <template v-slot:append>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M7.41 8.58008L12 13.1701L16.59 8.58008L18 10.0001L12 16.0001L6 10.0001L7.41 8.58008Z"
                fill="#939099" />
            </svg>
          </template>
        </v-select>
      </div>
      <div class="w-full">
        <div class="">
          <div v-for="(item, index) in Object.values(objectList)" :key="index">
            <div class="multi-step-quiz__quiz-container">
              <div>
                <div class="d-flex justify-space-between align-baseline">
                  <label class="multi-step-quiz__question-label" :for="`Question_${index + 1}`">
                    Question {{ index + 1 }}
                  </label>
                  <button class="multi-step-quiz__delete-question" @click="onDelete(item)">
                    {{ $t("shortcodes.multiStepQuiz.delete") }}
                  </button>
                </div>
                <textarea :id="`Question_${index + 1}`" class="multi-step-quiz__question" v-model="item.question">
                </textarea>
              </div>
              <h4 class="multi-step-quiz__question-label mb-2">
                {{ $t("shortcodes.multiStepQuiz.answers") }}
              </h4>
              <div class="d-flex flex-column align-center">
                <div v-for="(answers, index) in Object.values(item.answers)" :key="index" class="w-full mb-2">
                  <a class="step-button">
                    <div @click="deleteAnswer(item, answers)" class="step-button__exit">x</div>
                    <input v-model="answers.text" type="text" placeholder="Click & Write" />
                  </a>
                </div>
              </div>
              <button class="multi-step-quiz__button-add" @click="addAnswer(item)">
                {{ $t("shortcodes.multiStepQuiz.add_answer") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <button class="multi-step-quiz__button" @click="addItem()">{{ $t("shortcodes.multiStepQuiz.add_step") }}</button>
    </div>
  </div>
</template>

<script>
  import { encodeLinkSymbols } from "@/utility/encodeDecodeLinks";
  import { urlValidation } from "@/utility/urlValidation";
  import { decodeHtmlSymbols, encodeHtmlSymbols } from "@/utility/htmlEscape";

  export default {
    data() {
      return {
        paramData: null,
        objectList: {},
        redirectUrl: "",
        invalidUrl: false,
        redirectAction: "sameTab",
        rules: {
          urlValidation: v => !!urlValidation(v) || this.$t("generic.validation.url"),
        },
        actionData: [
          { text: "Open in same tab", value: "sameTab" },
          { text: "Open in new tab", value: "newTab" },
        ],
      };
    },
    watch: {
      objectList: {
        handler(newVal) {
          window.parent.postMessage(
            {
              mceAction: "updateComments",
              data: encodeHtmlSymbols(JSON.stringify(newVal)),
            },
            origin,
          );
        },
        deep: true,
      },
      redirectUrl: {
        handler(newVal) {
          this.invalidUrl = !urlValidation(newVal);

          Object.values(this.objectList).map(item => {
            item.url.link = encodeLinkSymbols(newVal);
          });
        },
      },
      redirectAction: {
        handler(newVal) {
          Object.values(this.objectList).map(item => {
            item.url.redirectAction = newVal;
          });
        },
      },
    },
    beforeMount() {
      this.paramData = this.$route.query.data;
    },
    mounted() {
      if (this.$refs?.paramData?.value !== "null") {
        const paramsString = JSON.parse(decodeHtmlSymbols(this.$refs.paramData.value));
        const passedData = JSON.parse(paramsString);
        if (passedData !== false) {
          this.redirectUrl = Object.values(passedData)[0].url.link;
          this.redirectAction = Object.values(passedData)[0].url.redirectAction;
          this.objectList = passedData;
        }
      } else {
        window.parent.postMessage(
          {
            mceAction: "updateComments",
            data: encodeHtmlSymbols(JSON.stringify(this.objectList)),
          },
          origin,
        );
      }
    },
    methods: {
      addItem() {
        if (!urlValidation(this.redirectUrl)) {
          this.invalidUrl = true;
        } else {
          this.invalidUrl = false;
          const newId = "_" + Math.random().toString(36).substr(2, 9);
          this.objectList = {
            ...this.objectList,
            [newId]: {
              url: {
                link: encodeLinkSymbols(this.redirectUrl),
                redirectAction: this.redirectAction,
              },
              question: "",
              answers: [{ text: "YES" }, { text: "NO" }],
            },
          };
        }
      },
      onDelete(item) {
        for (const i in this.objectList) {
          if (this.objectList[i] === item) {
            this.$delete(this.objectList, i);
          }
        }
      },
      addAnswer(item) {
        for (const i in this.objectList) {
          if (this.objectList[i] === item) {
            this.objectList[i].answers.push({ text: "" });
          }
        }
      },
      deleteAnswer(item, answers) {
        for (const i in this.objectList) {
          if (this.objectList[i] === item) {
            const delIndex = this.objectList[i].answers.indexOf(answers);
            this.objectList[i].answers.splice(delIndex, 1);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @tailwind base;
  @tailwind utilities;
  @tailwind components;

  .multi-step-quiz {
    background: white;
    height: calc(100% + 32px);
    width: calc(100% + 24px);
    margin-left: -12px;
    margin-top: -20px;
    padding-top: 28px;
    padding-left: 12px;
    padding-right: 12px;

    &__url-input {
      padding-bottom: 42px;
      &::v-deep {
        .v-input__slot {
          padding: 0 !important;
          min-height: 0 !important;
          border: 1px solid #dad9dd !important;

          fieldset {
            border: none !important;
          }
        }

        &.no-valid {
          .v-input__slot {
            border: 1px solid #ff4c51 !important;
          }
        }
      }
    }

    &__select {
      &::v-deep {
        .v-text-field__details {
          margin-bottom: 10px;
        }
        fieldset {
          border: none !important;
        }
      }
    }

    &__button {
      width: 100%;
      text-align: center;
      background-color: #f7f6ff;
      border: 1px dashed #ad9bf6;
      border-radius: 6px;
      padding: 8px;
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      color: #6a49ef;

      &-add {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        color: #6a49ef;
      }
    }

    &__quiz-container {
      border: 1px solid #dad9dd;
      padding: 12px;
      background-color: #fafafa;
      margin-bottom: 24px;
    }

    &__delete-question {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      color: #ff4c51;
      display: block;
    }

    &__question {
      width: 100%;
      padding: 12px;
      border: 1px solid #dad9dd;
      border-radius: 4px;
      background-color: #ffffff;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      color: #45404e;
      resize: none;
      margin-bottom: 8px;
      &:focus-visible {
        border: 1px solid #6a49ef;
        outline: none;
      }

      &-label {
        font-family: Inter, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        color: #6c6c7d;
        margin-bottom: 6px;
        display: block;
      }
    }
  }

  .step-button {
    background: #30c632;
    border: 2.205px solid #2bab2e;
    box-sizing: border-box;
    border-radius: 320px;
    font-weight: 700;
    font-size: 20px;
    line-height: 14px;
    text-align: center;
    text-transform: uppercase;
    padding: 11px 12px;
    color: #ffffff;
    display: block;
    width: 100%;
    position: relative;

    input {
      color: #ffffff;
      background: transparent;
      outline: none;
      border-bottom: 1px solid;
      text-align: center;
      &:not([value=""]):not(:focus) {
        border-color: transparent;
      }
    }

    &__exit {
      position: absolute;
      color: red;
      right: -6px;
      top: -6px;
      border: 2px solid red;
      padding: 5px;
      border-radius: 100%;
      background: white;
      font-size: 12px;
      width: 26px;
      height: 26px;
      line-height: 1;
      cursor: pointer;
      opacity: 0;
      transition: ease 0.2s;
    }

    &:hover {
      .step-button__exit {
        opacity: 1;
      }
    }
  }
</style>
